<template>
  <el-form :model="form" ref="form" size="mini">
    <el-form-item
      v-for="(floor, index) in form.floors"
      :label="
        $t('text.number_of_rooms') +
          ' (' +
          $t('text.floor') +
          ' ' +
          (index + 1) +
          ')'
      "
      :key="floor.key"
      :prop="'floors.' + index + '.numberOfRooms'"
      :rules="{
        required: true,
        message: $t('text.please_enter_number_of_rooms'),
        trigger: 'blur'
      }"
    >
      <el-input-number
        v-model="floor.numberOfRooms"
        :min="1"
        step-strictly
        class="wp-100"
      ></el-input-number>
    </el-form-item>
  </el-form>
</template>

<script>
export default {
  data() {
    return {
      form: {
        floors: []
      }
    }
  },
  props: {
    numberOfFloors: {
      type: Number,
      require: true
    }
  },
  watch: {
    numberOfFloors: {
      immediate: true,
      handler() {
        let floors = []
        for (let i = 1; i <= this.numberOfFloors; i++) {
          floors.push({
            numberOfRooms: 1,
            key: i
          })
        }
        this.$set(this.form, 'floors', floors)
      }
    }
  },
  methods: {
    generateBuildingStructure() {
      let floors = []
      for (let i = 0; i < this.numberOfFloors; i++) {
        let rooms = []
        for (let r = 0; r < this.form.floors[i].numberOfRooms; r++) {
          rooms.push({
            id: Math.random(),
            label: 'Room ' + (r + 1),
            type: 'room'
          })
        }
        floors.push({
          id: Math.random(),
          label: 'Floor ' + (i + 1),
          type: 'floor',
          children: rooms
        })
      }
      return floors
    }
  }
}
</script>
